import { Navbar } from '../../components/layout/Navbar';
import { Hero } from '../../components/sections/Hero';
import { About } from '../../components/sections/About';
import { Timeline } from '../../components/sections/Timeline';
import { Projects } from '../../components/sections/Projects';
import { Services } from '../../components/sections/Services';
import { Skills } from '../../components/sections/Skills';
import { Contact } from '../../components/sections/Contact';
import { Footer } from '../../components/sections/Footer';

export default function Home() {
    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <About />
                <Timeline />
                <Projects />
                <Services />
                <Skills />
                <Contact />
            </main>
            <Footer />
        </>
    );
}
